// extracted by mini-css-extract-plugin
module.exports = {"content":"Alliance_content__RkcWl","con":"Alliance_con__3Fb9u","title":"Alliance_title__bCMSF","box":"Alliance_box__Q6Hwy","img":"Alliance_img__1AKE2"};